import styled from "styled-components";

interface Props {
	hint?: string | React.ReactNode;
	className?: string;
	children?: React.ReactNode;
}

export const Label: React.FC<Props> = ({ hint, className, children }) => {
	return (
		<Styles className={className}>
			{children} {hint && <span className="hint">{hint}</span>}
		</Styles>
	);
};

const Styles = styled.label`
	display: block;
	font-size: 0.9rem;
	font-weight: 500;
	margin: 0;
	color: ${(props) => props.theme.colors.textDimmed};

	.hint {
		font-weight: 400;
		margin: 0 0 0 0.5rem;
		font-size: 0.75rem;
	}
`;
